import type { MarketDetail } from 'shared/src/api';

const BASE_TITLE = '에이블리';

/**
 * 상품 기본 정보에서 스토어명을 추출합니다.
 */
const getStoreName = (market: MarketDetail) => {
  // return goods.brand?.name ?? goods.market.name;
  return market.market.name;
};

/**
 * 상품 기본 정보에서 공통 메타 데이터를 추출합니다.
 */
export const extractMetaData = (market: MarketDetail) => {
  return {
    // goodsName: goods.name,
    marketName: getStoreName(market),
  };
};

export const getMetaTitle = (market: MarketDetail) => {
  const { marketName } = extractMetaData(market);

  return `${marketName} - ${BASE_TITLE}`;
};

export const getMetaImage = (market: MarketDetail) => {
  return market.market.image;
};
